/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import TextField from '@material-ui/core/TextField';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  maintainContractActions,
  handleErrorMessages,
  getDisputeContactDetails,
} from '../store/actions';
import SelectContractModal from './SelectContractModal';
import CommonModal from './CommonModal';
import { ShowContractUsingContacts } from './CreateContractModal';

const DisputeContact = ({ isEnablebyRole = true }) => {
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const disputeContract = useSelector(
    (state) =>
      state.sharedState.ContractReducer.maintainContractState.disputeContract
  );
  const searchContractState = useSelector(
    (state) => state.sharedState.ContractReducer.searchContractState
  );
  const errorMessagesFromRedux = useSelector((state) => {
    return state?.sharedState?.ContractReducer?.errorMessagesInRedux;
  });
  const getDisputeContractContactDetails = useSelector(
    (state) =>
      state.sharedState?.ContractReducer?.getDisputeContractContactDetails
  );
  const today = new Date();
  const yyyy = today.getFullYear();
  const mm = today.getMonth() + 1; // Months start at 0!
  const dd = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate();
  const currDate = `${mm}/${dd}/${yyyy}`;
  // const logInUserID = localStorage.getItem('logInUser');
  const [open, setOpen] = React.useState(false);
  const [selectedContact, setSelectedContact] = React.useState(null);
  const [showContractPop, setShowContractPop] = React.useState(false);
  const [windowWidth, setWindowWidth] = React.useState(window.screen.width);
  const logInUser = useSelector(
    (state) => state?.sharedState?.SharedReducer?.logInUser
  );
  const copyContract = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
  };

  // Set lable text according to the screen width for Phone number
  const textReplace = () => {
    setWindowWidth(window.screen.width);
  };
  React.useEffect(() => {
    window.addEventListener('resize', textReplace);
  }, [windowWidth]);

  React.useEffect(() => {
    if (
      getDisputeContractContactDetails &&
      Object.keys(getDisputeContractContactDetails).length > 0
    ) {
      let localErr = errorMessagesFromRedux || [];
      const selectedContact = { ...getDisputeContractContactDetails };
      const data = { ...disputeContract };
      data.manufacturerID = selectedContact.mfgId || '';
      data.manufacturerName = selectedContact.mfgName || '';
      data.contactTypeCode = selectedContact.contactTypeCd || '';
      data.description = selectedContact.shortDescr || '';
      data.contactName = selectedContact.contactName || '';
      data.corpName = selectedContact.corpName || '';
      data.addrLine1 = selectedContact.addrLine1 || '';
      data.addrLine2 = selectedContact.addrLine2 || '';
      data.addrLine3 = selectedContact.addrLine3 || '';
      data.city = selectedContact.city || '';
      data.stateCd = selectedContact.stateCd || '';
      data.zip = selectedContact.zip || '';
      data.zip4 = selectedContact.zip4 || '';
      data.phoneNum = selectedContact.phoneNum || '';
      data.phoneExtension = selectedContact.phoneExtension || '';
      data.faxNum = selectedContact.faxNum || '';
      data.email = selectedContact.email || '';
      data.addressChangedInd = selectedContact.addressChangedInd || '';
      data.contactSeqNum = selectedContact.contactSeqNum || '';
      data.contactTypeCd = selectedContact.contactTypeCd || null;
      data.copySourceSeqNum = selectedContact.copySourceSeqNum || null;
      data.corrLinkId = selectedContact.corrLinkId || null;
      data.key = selectedContact.mfgId;
      data.keyTypeCd = selectedContact.keyTypeCd;
      data.lastUpdateDT = `${currDate} 00:00`;
      data.lastUpdateUserID = logInUser;
      data.nameChangedInd = selectedContact.nameChangedInd || null;
      data.needsAttentionCd = selectedContact.needsAttentionCd || null;

      const newData = {
        ...maintainContractState,
        disputeContract: {
          ...disputeContract,
          ...data,
        },
      };
      dispatch(maintainContractActions(newData));
      localErr = localErr?.filter((x) => x.tabName !== 'DisputeContact');
      dispatch(handleErrorMessages([...new Set(localErr)]));
    }
  }, [getDisputeContractContactDetails]);
  const setContactIfNotEmpty = (data) => {
    if (data) {
      dispatch(
        getDisputeContactDetails({
          contactSeqNum: data.contactSeqNum,
          type: 'Dispute',
        })
      );
    }
    handleClose();
  };
  const showContractusingContact = () => {
    setShowContractPop(true);
  };
  return (
    <div data-testid="DisputeContact-component">
      <div className="float-right">
        <OverlayTrigger
          placement="bottom"
          overlay={<Tooltip id="action-tooltip">Action</Tooltip>}
        >
          <Dropdown className="icon-dropdown-container frr-lab-diff-action-icon-container">
            <Dropdown.Toggle
              className="icon-dropdown"
              aria-label="Show Contracts using this Contact"
            >
              <SVGComponent iconName="Icon-export" />
            </Dropdown.Toggle>
            <Dropdown.Menu>
              <Dropdown.Item
                role="button"
                data-testid="showContracts"
                disabled={searchContractState.contractType !== 'onSelect'}
                onClick={() => {
                  if (searchContractState.contractType === 'onSelect') {
                    showContractusingContact();
                  }
                }}
              >
                Show Contracts using this Contact
              </Dropdown.Item>
              <Dropdown.Item
                role="button"
                data-testid="copyContractData"
                disabled={!isEnablebyRole}
                onClick={() => {
                  copyContract();
                }}
              >
                Copy Contact From
              </Dropdown.Item>
            </Dropdown.Menu>
          </Dropdown>
        </OverlayTrigger>
      </div>
      <div className="my-3 pt-4">
        <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
          <legend className="same-font-family">Search Criteria</legend>
          <div className="form-wrapper db">
            <div className="row">
              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md">
                  <TextField
                    id="ManufacturerID"
                    // required
                    disabled
                    className="mandate-fields"
                    label="Manufacturer ID"
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ id: 'ManufacturerID' }}
                    value={disputeContract.manufacturerID}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'manufacturerID' &&
                                    x.tabName === 'DisputeContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter(
                        (x) =>
                          x.fieldName === 'manufacturerID' &&
                          x.tabName === 'DisputeContact'
                      ).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'manufacturerID' &&
                                    x.tabName === 'DisputeContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
              </div>
              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md">
                  {disputeContract?.manufacturerName?.length > 20 ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {disputeContract?.manufacturerName}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="ManufacturerName"
                        // required
                        disabled
                        className="mandate-fields"
                        label="Manufacturer Name"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ id: 'ManufacturerName' }}
                        value={disputeContract.manufacturerName}
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'manufacturerName' &&
                                        x.tabName === 'DisputeContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter(
                            (x) =>
                              x.fieldName === 'manufacturerName' &&
                              x.tabName === 'DisputeContact'
                          ).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'manufacturerName' &&
                                        x.tabName === 'DisputeContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id="ManufacturerName"
                      // required
                      disabled
                      className="mandate-fields"
                      label="Manufacturer Name"
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ id: 'ManufacturerName' }}
                      value={disputeContract.manufacturerName}
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'manufacturerName' &&
                                      x.tabName === 'DisputeContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.length > 0 &&
                        errorMessagesFromRedux?.filter(
                          (x) =>
                            x.fieldName === 'manufacturerName' &&
                            x.tabName === 'DisputeContact'
                        ).length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'manufacturerName' &&
                                      x.tabName === 'DisputeContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  )}
                </div>
              </div>
              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md ">
                  <TextField
                    disabled
                    id="ContactTypeCode"
                    className="mandate-fields"
                    label="Contact Type Code"
                    // required
                    InputLabelProps={{ shrink: true }}
                    inputProps={{ id: 'ContactTypeCode' }}
                    value={disputeContract.contactTypeCode}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'contactTypeCode' &&
                                    x.tabName === 'DisputeContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter(
                        (x) =>
                          x.fieldName === 'contactTypeCode' &&
                          x.tabName === 'DisputeContact'
                      ).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter(
                                  (x) =>
                                    x.fieldName === 'contactTypeCode' &&
                                    x.tabName === 'DisputeContact'
                                )
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
              </div>
              <div className="col-12 col-sm-3 col-lg-4 col-xl-3">
                <div className="mui-custom-form input-md">
                  {disputeContract?.description?.length > 20 ? (
                    <OverlayTrigger
                      placement="bottom"
                      overlay={
                        <Tooltip id="com-tooltip">
                          {disputeContract?.description}
                        </Tooltip>
                      }
                    >
                      <TextField
                        id="Description"
                        disabled
                        className="mandate-fields"
                        label="Description"
                        // required
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ id: 'Description' }}
                        value={disputeContract.description}
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'description' &&
                                        x.tabName === 'DisputeContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter(
                            (x) =>
                              x.fieldName === 'description' &&
                              x.tabName === 'DisputeContact'
                          ).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter(
                                      (x) =>
                                        x.fieldName === 'description' &&
                                        x.tabName === 'DisputeContact'
                                    )
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </OverlayTrigger>
                  ) : (
                    <TextField
                      id="Description"
                      disabled
                      className="mandate-fields"
                      label="Description"
                      // required
                      InputLabelProps={{ shrink: true }}
                      inputProps={{ id: 'Description' }}
                      value={disputeContract.description}
                      helperText={
                        errorMessagesFromRedux?.length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'description' &&
                                      x.tabName === 'DisputeContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : null
                      }
                      error={
                        errorMessagesFromRedux?.length > 0 &&
                        errorMessagesFromRedux?.filter(
                          (x) =>
                            x.fieldName === 'description' &&
                            x.tabName === 'DisputeContact'
                        ).length > 0
                          ? [
                              ...new Set(
                                errorMessagesFromRedux
                                  ?.filter(
                                    (x) =>
                                      x.fieldName === 'description' &&
                                      x.tabName === 'DisputeContact'
                                  )
                                  .map((item) => {
                                    return item.subMessage || item.message;
                                  })
                              ),
                            ]
                          : false
                      }
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </fieldset>
      </div>
      <div className="my-2">
        <form autoComplete="off">
          <div className="frr-dispute-other-info">
            <fieldset className="custom-fieldset custom-height">
              <legend aria-hidden="true" className="d-none" />
              <div className="form-wrapper">
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Name"
                    disabled
                    label="Name"
                    data-testid="name"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Name' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={disputeContract?.contactName}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="CorporationName"
                    disabled
                    label="Corporation Name"
                    data-testid="Corporation-name"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'CorporationName' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState.disputeContract.corpName}
                  />
                </div>
                <div className="mui-custom-form input-md" />
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Address Lines"
                    disabled
                    data-testid="Address-line"
                    label="Address Lines 1"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Address Lines' }}
                    InputLabelProps={{ shrink: true }}
                    value={disputeContract.addrLine1}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="address-line2"
                    label="Address Lines 2"
                    disabled
                    data-testid="address-line2"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'address-line2' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={disputeContract.addrLine2}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="address-lines3"
                    disabled
                    label="Address Lines 3"
                    data-testid="address-lines3"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'address-lines3' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.disputeContract.addrLine3}
                  />
                </div>
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <TextField
                    id="city"
                    data-testid="city"
                    disabled
                    label="City"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 30, id: 'city' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.disputeContract.city}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="State"
                    label="State"
                    disabled
                    data-testid="state"
                    className="mandate-fields"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 2, id: 'State' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.disputeContract.stateCd}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <div className="row">
                    <div className="col-sm-6 col-md-7 pr-sm-0 pr-md-2">
                      <TextField
                        id="Zip"
                        disabled
                        label="Zip"
                        data-testid="zip"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 10, id: 'Zip' }}
                        InputLabelProps={{ shrink: true }}
                        value={maintainContractState.disputeContract.zip}
                      />
                    </div>
                    <div className="col-sm-6 col-md-5 mt-md-0 pl-md-0">
                      <TextField
                        id="Zip+4"
                        disabled
                        label="Zip+4"
                        data-testid="zip4"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 4, id: 'Zip+4' }}
                        InputLabelProps={{ shrink: true }}
                        value={maintainContractState.disputeContract.zip4}
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'zip4' &&
                                        x.tabName === 'DisputeContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return (
                              x.fieldName === 'zip4' &&
                              x.tabName === 'DisputeContact'
                            );
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'zip4' &&
                                        x.tabName === 'DisputeContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="line-break-div" />
                <div className="mui-custom-form input-md">
                  <div className="row">
                    <div className="col-sm-6 col-md-7 pr-sm-0 pr-md-2">
                      <TextField
                        id="Phone Number"
                        disabled
                        label={
                          windowWidth >= 745 ? 'Phone Number' : 'Phone No.'
                        }
                        data-testid="phone"
                        className="mandate-fields"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 10, id: 'Phone Number' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          maintainContractState.disputeContract.phoneNum
                            ? maintainContractState.disputeContract.phoneNum.trim()
                            : ''
                        }
                        helperText={
                          errorMessagesFromRedux?.length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'phoneNum' &&
                                        x.tabName === 'DisputeContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : null
                        }
                        error={
                          errorMessagesFromRedux?.length > 0 &&
                          errorMessagesFromRedux?.filter((x) => {
                            return (
                              x.fieldName === 'phoneNum' &&
                              x.tabName === 'DisputeContact'
                            );
                          }).length > 0
                            ? [
                                ...new Set(
                                  errorMessagesFromRedux
                                    ?.filter((x) => {
                                      return (
                                        x.fieldName === 'phoneNum' &&
                                        x.tabName === 'DisputeContact'
                                      );
                                    })
                                    .map((item) => {
                                      return item.subMessage || item.message;
                                    })
                                ),
                              ]
                            : false
                        }
                      />
                    </div>
                    <div className="col-sm-6 col-md-5 mt-md-0 pl-md-0">
                      <TextField
                        id="Extension"
                        disabled
                        label="Extension"
                        data-testid="Extension"
                        fullWidth
                        placeholder=""
                        inputProps={{ maxLength: 6, id: 'Extension' }}
                        InputLabelProps={{ shrink: true }}
                        value={
                          maintainContractState.disputeContract.phoneExtension
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Fax Number"
                    disabled
                    label="Fax Number"
                    data-testid="fax"
                    fullWidth
                    placeholder=""
                    inputProps={{ maxLength: 10, id: 'Fax Number' }}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={maintainContractState.disputeContract.faxNum}
                  />
                </div>
                <div className="mui-custom-form input-md">
                  <TextField
                    id="Email Address"
                    disabled
                    label="Email Address"
                    data-testid="email"
                    className="mandate-fields"
                    fullWidth
                    type="text"
                    placeholder=""
                    inputProps={{ maxLength: 50, id: 'Email Address' }}
                    InputLabelProps={{ shrink: true }}
                    value={maintainContractState.disputeContract.email}
                    helperText={
                      errorMessagesFromRedux?.length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return (
                                    x.fieldName === 'email' &&
                                    x.tabName === 'DisputeContact'
                                  );
                                })
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : null
                    }
                    error={
                      errorMessagesFromRedux?.length > 0 &&
                      errorMessagesFromRedux?.filter((x) => {
                        return (
                          x.fieldName === 'email' &&
                          x.tabName === 'DisputeContact'
                        );
                      }).length > 0
                        ? [
                            ...new Set(
                              errorMessagesFromRedux
                                ?.filter((x) => {
                                  return (
                                    x.fieldName === 'email' &&
                                    x.tabName === 'DisputeContact'
                                  );
                                })
                                .map((item) => {
                                  return item.subMessage || item.message;
                                })
                            ),
                          ]
                        : false
                    }
                  />
                </div>
              </div>
            </fieldset>
          </div>
        </form>
      </div>
      <SelectContractModal
        disputeContract
        invoiceContact={false}
        setSelectedContact={setSelectedContact}
        open={open}
        handleClose={handleClose}
        setContactIfNotEmpty={setContactIfNotEmpty}
        handleOpenPopUp={copyContract}
      />

      <CommonModal
        open={showContractPop}
        viewAction
        viewHeader
        modalTitle="Show Contracts using this Contact"
        className="panel-header"
        okTitle="Ok"
        onOk={() => {
          setShowContractPop(false);
        }}
        onClose={() => {
          setShowContractPop(false);
        }}
        childrenComponent={
          <ShowContractUsingContacts
            contactSeqNum={disputeContract.contactSeqNum}
          />
        }
      />
    </div>
  );
};
export default DisputeContact;
